"use client";

import { getTheme, CustomAppPalette } from "@patron/utils/theme";
import React from "react";
import { CssBaseline, LicenseInfo, ThemeProvider } from "@bpipartners/webui";
import { SnackbarProvider } from "notistack";
import { AppContext, GlobalModalProvider } from "@patron/utils/context";
import { FaroErrorBoundary } from "@grafana/faro-react";
import { ObservabilityProviderWrapper } from "./NewFaro";
import { FallbackErrorComponent } from "@patron/ui/error-component";

import { ErrorBoundary } from "react-error-boundary";
import { WebuiClientWrapper } from "./_useWcWebuiWrapper";

LicenseInfo.setLicenseKey(
  "2167094a0e47fd879a30e3d04f2a2736Tz0xMjEwMDgsRT0xNzk1MTMyNzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI=",
);

export const ClientProviders = ({
  children,
  isAnalticsEnabled,
  customPalette,
}: {
  children?: React.ReactNode;
  isAnalticsEnabled?: string;
  customPalette?: CustomAppPalette;
}) => {
  const { localAppState } = React.useContext(AppContext);
  const shouldRenderErroBoundry = () => {
    if (isAnalticsEnabled === "false") {
      return <ErrorBoundary FallbackComponent={FallbackErrorComponent}></ErrorBoundary>;
    } else {
      return (
        <FaroErrorBoundary
          fallback={(error, reset) => FallbackErrorComponent({ error, resetErrorBoundary: reset })}
        ></FaroErrorBoundary>
      );
    }
  };
  return (
    <ThemeProvider theme={getTheme(customPalette)}>
      <ObservabilityProviderWrapper isAnalysticsEnabled={isAnalticsEnabled === "true"} version={localAppState?.appVersion || ""}>
        <SnackbarProvider autoHideDuration={3000} maxSnack={3} anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
          {shouldRenderErroBoundry()}
          <GlobalModalProvider>
            <CssBaseline />
            <WebuiClientWrapper>{children}</WebuiClientWrapper>
          </GlobalModalProvider>
        </SnackbarProvider>
      </ObservabilityProviderWrapper>
    </ThemeProvider>
  );
};
